import { render, staticRenderFns } from "./LayoutIndexLeft.vue?vue&type=template&id=64c13514&scoped=true&"
import script from "./LayoutIndexLeft.vue?vue&type=script&lang=js&"
export * from "./LayoutIndexLeft.vue?vue&type=script&lang=js&"
import style0 from "./LayoutIndexLeft.vue?vue&type=style&index=0&id=64c13514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c13514",
  null
  
)

export default component.exports